module.exports = __webpack_public_path__ + "static/awards-logo2-b7af7bf7bcb6385449f289ceaccccbb3.jpg";